import { Modal } from '@aloft/toolkit-sui';

export function DeleteConfirmationModal({
  isDeleteModalOpen,
  closeDeleteModal,
  title,
  removeComp,
}: {
  isDeleteModalOpen: boolean;
  closeDeleteModal: () => void;
  title: string;
  removeComp: () => void;
}) {
  return (
    <Modal
      size="lg"
      isOpen={isDeleteModalOpen}
      onClose={closeDeleteModal}
      closeOnEsc
      title={`Delete ${title}`}
      primaryAction={{
        id: 'delete-comp-btn',
        text: 'Delete',
        onClick: () => {
          removeComp();
          closeDeleteModal();
        },
      }}
      secondaryAction={{
        text: 'Cancel',
        onClick: closeDeleteModal,
      }}
    >
      Deleting {title} cannot be undone. Any work on {title} will be lost.
    </Modal>
  );
}
